export const formatCurrency = (v) => {
  const n = Number(v || 0);
  return (
    "₹" +
    n.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    })
  );
};

// Indian short-scale words for a rupee amount, e.g. 15500000 -> "1.55 Crore"
export const amountInWords = (v) => {
  const n = Math.abs(Number(v || 0));
  if (n >= 1e7) return `${(n / 1e7).toFixed(2)} Crore`;
  if (n >= 1e5) return `${(n / 1e5).toFixed(2)} Lakh`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(2)} Thousand`;
  return "";
};

export const formatDate = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d.getTime())) return v;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

export const todayISO = () => new Date().toISOString().slice(0, 10);
